import { message } from 'antd'
import { emailValuation } from '../../../HttpRequests/valuations';
import { setFileList } from '../State/fileList';
import { resetAllFiles } from '../State/allFiles';
import { resetSelectedPaths } from '../State/selectedPaths';
import handleException from '../../../Core/Helpers/handleException';

export default (values) => async (dispatch, getState) => {

  try {

    const { id } = values;

    const data = new FormData();

    data.append('to', values.to.join(','));
    data.append('cc', values.cc.join(','));
    data.append('bcc', values.bcc.join(','));
    data.append('subject', values.subject);
    data.append('body', values.body);

    const { fileList, selectedPaths } = getState().modals.EmailValuation;

    fileList.forEach((file) => {
      data.append('files[]', file);
    });

    selectedPaths.forEach((path) => {
      data.append('paths[]', path);
    });

    await emailValuation({ id, data });

    message.success("Mail Queued");

    dispatch(setFileList([]));
    dispatch(resetAllFiles([]));
    dispatch(resetSelectedPaths([]));

    return true;

  } catch(error) {

    handleException(error);

    return false;
  }
}
